import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { Translates } from '../../ph-simple-table/translates';
import { TranslateService } from "@ngx-translate/core";
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { SHARED_MODULES } from '../../../../shared.';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

type LastChangeDtypeElement = {
	source: string;
	date: string;
}

@Component({
    selector: 'app-last-change-dtype',
    templateUrl: 'last-change-dtype.component.html',
	imports: [SHARED_MODULES],
    standalone: true
})
export class LastChangeDtypeComponent implements OnInit {
	element: LastChangeDtypeElement;
	translates = Translates;

	constructor(
		@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<LastChangeDtypeElement>,
		private translateService: TranslateService
	) {}

	ngOnInit(): void {
		this.element = { ...this.elementInjected.element };

		if (this.elementInjected.isTranslate && this.translates[this.element.source]) {
			this.translateService
				.get(this.translates[this.element.source])
				.subscribe((value: string) => this.element.source = value);
		}
	}
}
